import React, { Suspense } from 'react';
import { ConnectedRouter as Router } from 'react-router-redux';
import { Switch, Route } from 'react-router-dom';
import App from '../pages/app';
import Login from '../pages/login';
import NotFoundPage from '../pages/common/NotFoundPage';

// Use window.location for all redirects to avoid react-router-redux/history crash
// (react-router-redux@5.0.0-alpha.9 + history@4.10.1 compatibility issue)
const navigateTo = (path) => {
  window.location.replace(path);
  return null;
};

export default (store) => {
  const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthed = localStorage.getItem('id_token');
    return (
      <Route
        {...rest}
        render={(props) => {
          if (isAuthed) {
            return <Component {...props} />;
          }
          return navigateTo('/login');
        }}
      />
    );
  };

  const LoginRedirectRoute = ({ component: Component, ...rest }) => {
    const isAuthed = localStorage.getItem('id_token');
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthed ? navigateTo('/app') : <Component {...props} />
        }
      />
    );
  };

  const routes = (
    <Router history={store.history}>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              const isAuthed = localStorage.getItem('id_token');
              if (isAuthed) {
                return navigateTo('/app');
              }
              return navigateTo('/login');
            }}
          />

          <PrivateRoute path="/app" component={App} />
          <LoginRedirectRoute path="/login" component={Login} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Suspense>
    </Router>
  );

  return routes;
};
